import _ from "lodash";

export function calculateRadioCoverageRadius(height: number, radiusFromHeight: {height: number, radius: number}[]): number | "not-available" {
  return _.last(radiusFromHeight.filter((i) => height >= i.height))?.radius ?? "not-available";
}
